import { VehiclePlan } from '../types';

/**
 * Orders vehicle plans by the provided ordering.
 *
 * @param vehiclePlans Deserialized vehicle plans
 * @param ordering List of vehicle plan IDs in the desired order
 * @returns List of vehicle plans ordered by provided ordering
 */
export default function reorderVehiclePlans(
  vehiclePlans: VehiclePlan[],
  ordering?: number[]
): VehiclePlan[] {
  if (!ordering) {
    return vehiclePlans;
  }

  return ordering
    .map((index) => vehiclePlans.find((plan) => plan.id === index))
    .filter(Boolean) as VehiclePlan[];
}
